import axios from "axios";
import {
  clearLocalStorage,
  getAccessToken,
  getRefreshTokenAndEmail,
  setToken,
} from "../../share/utils";
import { getRefreshToken } from "../auth";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_KEY}api/v1/`,
});
// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    if (error.response && error.response.data.statusCode === 401) {
      const payload = getRefreshTokenAndEmail();
      const refreshToken = await getRefreshToken(payload);
      if (refreshToken) {
        setToken(refreshToken.accessToken, refreshToken.refreshToken);
        window.location.reload();
      }
      return Promise.resolve(null);
    } else if (error.response && error.response.data.statusCode === 403) {
      // clearLocalStorage();
      // window.location.href = "/login";
      return Promise.resolve(null);
    }
    return Promise.reject(error);
  }
);

export const axiosGet = async ({ path }) => {
  const res = await instance.get(path, {withCredentials: true});
  return res;
};

export const axiosGetManualToken = async ({ path, token }) => {
  const res = await instance.get(path, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const axiosPost = async ({ path, payload }) => {
  const res = await instance.post(path, payload);
  return res;
};

export const axiosPatch = async ({ path, payload }) => {
  const res = await instance.patch(path, payload);
  return res;
};

export const axiosDelete = async ({ path }) => {
  const res = await instance.delete(path);
  return res;
};
